import useQueryParams from '@common/src/hooks/useQueryParams';
import FlowProductsSidebar, {
  FlowProductsSidebarItem,
} from '@flows/src/components/flow-products/FlowProductsSidebar';
import { useYellowhiveQuotes } from '@flows/src/api/yellowhive-flows';
import YellowhiveFlowProductsSideBarBasketPriceSummary from '@flows/src/components/flow-products/YellowhiveFlowProductsSideBarBasketPriceSummary';

const YellowhiveFlowProductsSidebar = () => {
  const queryParams = useQueryParams();
  const sessionId = queryParams.get('session_id') || undefined;
  const { data } = useYellowhiveQuotes({
    sessionId,
    queryOptions: { enabled: !!sessionId },
  });
  const isBasketPage = window.location.pathname.includes('basket');

  const sideBarItems: FlowProductsSidebarItem[] = [];
  if (data?.quotes) {
    for (const { insurance } of data.quotes) {
      if (!sideBarItems.some((item) => item.key === insurance.code)) {
        sideBarItems.push({
          key: insurance.code,
          label: insurance.name,
        });
      }
    }
  }

  return (
    <FlowProductsSidebar
      items={sideBarItems}
      isHidden={window.location.pathname.includes('selection-overview')}
      cartComponent={
        isBasketPage ? (
          <YellowhiveFlowProductsSideBarBasketPriceSummary />
        ) : null
      }
      basketItemsComponent={null}
    />
  );
};

export default YellowhiveFlowProductsSidebar;
